import { useEffect, useState } from 'react'
import * as React from 'react'
import { Alert, Table } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons'
import DisplayItemHelper from '../../../util/DisplayItemHelper'
import LoadingData from '../../../Components/Elements/Loading/LoadingData.jsx'
import {
    IDossierList,
    useDossierService,
} from '../../../context/DossierServiceContext'
import { useEntityService } from '../../../context/EntityServiceContext'
import ContentDossierIndexBody from './ContentDossierIndexBody'
import ContentDossierIndexFooter from './ContentDossierIndexFooter'
import ContentDossierIndexHeader from './ContentDossierIndexHeader'
import SearchDefDossier from '../../../Components/Pages/DefDossier/SearchDefDossier.jsx'
import DossierModalEditButton from '../../../Components/Elements/DossierModalEditButton.jsx'
import ExpiredModal from '../../../Components/Pages/Upgrade/ExpiredModal.jsx'
import { useSocketService } from '../../../context/SocketServiceContext'

interface ContentDossierIndexProps {
    props: any
    kedo: any
    forwardedRef?: any
}

export interface ContentDossierIndexHandle {
    fetchNewDossier(dossierId, isNew?): void
    doSearch(searchParams, dossierQuery, archived?): void
    onChangePage(number): void
}

const ContentDossierIndex: React.ForwardRefRenderFunction<
    ContentDossierIndexHandle,
    ContentDossierIndexProps
> = ({ props, kedo, forwardedRef }) => {
    const savedLimit = kedo.utils().getSavedLimit(props.defDossierId)
    const dossierService = useDossierService()
    const socketService = useSocketService()
    const entityService = useEntityService()
    const [loadingContent, setLoadingContent] = useState(false)
    const [loading, setLoading] = useState(false)
    const [inlineEdit, setInlineEdit] = useState(false)
    const [error, setError] = useState(false)
    const [expired, setExpired] = useState(false)
    const [showArchived, setShowArchived] = useState(false)
    const [archived, setArchived] = useState(null)
    const [pager, setPager] = useState({})
    const [searchItems, setSearchItems] = useState([])
    const [listItems, setListItems] = useState([])
    const [dossiers, setDossiers] = useState([])
    const [contents, setContents] = useState([])
    const [actionBtns, setActionBtns] = useState([])
    const [subscriptions, setSubscriptions] = useState([])
    const [socketDossierIds, setSocketDossierIds] = useState([])
    const [aggregations, setAggregations] = useState([])
    const [resultAggregations, setResultAggregations] = useState({})
    const [selected, setSelected] = useState([])
    const [sort, setSort] = useState([])
    const [isInitialized, setIsInitialized] = useState(false)
    const [limit, setLimit] = useState(
        savedLimit?.pager?.limit ? savedLimit?.pager?.limit : 50
    )
    const [page, setPage] = useState(
        savedLimit?.pager?.current ? savedLimit?.pager?.current : 0
    )
    const [advancedSearch, setAdvancedSearch] = useState(null)
    const [searchParams, setSearchParams] = useState([])

    const [dossierQuery, setDossierQuery] = useState(
        props.dossierQuery ? props.dossierQuery : null
    )

    const [customView, setCustomView] = useState(
        props.customView ? props.customView : null
    )

    React.useImperativeHandle(forwardedRef, () => ({
        fetchNewDossier(dossierId, isNew) {
            fetchNewDossier(dossierId, isNew)
        },
        doSearch(searchVals, dossierQuery, archived) {
            doSearch(searchVals, dossierQuery, archived)
        },
        onChangePage(number) {
            onChangePage(number)
        },
    }))

    const fetchNewDossier = (dossierId, isNew = true) => {
        if (isNew) {
            //let newSocketDossiers = socketDossierIds
            socketDossierIds.push(dossierId)
        }

        const filter = getSearchFilter()

        if (aggregations && aggregations.length > 0) {
            for (let i = 0; i < aggregations.length; i++) {
                filter[aggregations[i].id + '_aggregate'] =
                    aggregations[i].aggregate
            }
        }

        filter.archived = archived

        filter.dossierId = dossierId

        if (props.view) {
            filter.view = props.view
        }

        const originalResults = {
            contents: contents,
            dossiers: dossiers,
        }
        kedo.api()
            .get(kedo.api().getContentDossierEndpoint(), {
                params: filter,
            })
            .then((response) => {
                const newContents = [
                    ...originalResults.contents,
                    ...response.data.results.contents,
                ]
                originalResults.contents = newContents

                const newDossiers = [
                    ...response.data.results.dossiers,
                    ...originalResults.dossiers,
                ]
                originalResults.dossiers = newDossiers

                setError(false)
                setDossiers(newDossiers)
                setContents(newContents)
                //results: originalResults;
            })
    }

    const handleDossierModal = (remove, close) => {
        if (remove) {
            fetchDossierResults()
        }

        if (close) {
            setInlineEdit(false)
        }
    }

    const fetchDossierResults = async (IgnoreInitialized?: boolean) => {
        if (!isInitialized && IgnoreInitialized !== true) {
            return
        }

        setLoadingContent(true)
        const filter = getSearchFilter()
        if (aggregations && aggregations.length > 0) {
            for (let i = 0; i < aggregations.length; i++) {
                filter[aggregations[i].id + '_aggregate'] =
                    aggregations[i].aggregate
            }
        }

        filter.archived = archived

        if (customView) {
            filter.view = customView
        }

        if (props.view) {
            filter.view = props.view
        }

        const dossierList = (await dossierService.getDossiers(
            filter
        )) as IDossierList

        if (props.callBackPager) {
            props.callBackPager(dossierList.pager)
        } else {
            setPager(dossierList.pager)
        }

        setDossiers(dossierList.dossiers)
        setContents(dossierList.contents)
        setResultAggregations(dossierList.aggregations)
        setListItems(
            DisplayItemHelper.filterViews(
                dossierList.items.filter(
                    (item) =>
                        !DisplayItemHelper.isTypeOfField(
                            item,
                            DisplayItemHelper.FIELD_CUSTOMACTIONBTN_TYPE
                        )
                ),
                [
                    props.customView
                        ? props.customView
                        : props.view
                        ? props.view
                        : DisplayItemHelper.LIST_VIEW,
                ]
            )
        )
        setActionBtns(
            dossierList.items.filter(
                (item) =>
                    DisplayItemHelper.isTypeOfField(
                        item,
                        DisplayItemHelper.FIELD_CUSTOMACTIONBTN_TYPE
                    ) === true
            )
        )

        setLoadingContent(false)
    }

    const onDeleteSuccess = () => {
        setSelected([])

        socketService.displayItem.delete({
            defDossierId: props.defDossierId,
            sender: socketService.socket()?.id,
            room:
                window.location.pathname.split('/')[1] !== 'contentdossier'
                    ? 'environment:' + kedo.env().getEnvironmentId()
                    : null,
        })

        fetchDossierResults()
    }

    const loadSocketCallbacks = () => {
        socketService.displayItem.fetchListener((data) => {
            if (
                socketService.socket().id !== data.sender.id &&
                data.defDossierId === props.defDossierId
            ) {
                fetchDossierResults(true)
            }
        })
    }

    const doSearch = (searchVals, dossierQuery, archived) => {
        setArchived(archived)
        setSearchParams([...searchVals])
        setDossierQuery(dossierQuery)
    }

    useEffect(() => {
        fetchDossierResults()

        props && props.embedded ? loadSocketCallbacks() : null

        return () => {
            props && props.embedded
                ? socketService.displayItem.removeDdiListeners()
                : null
        }
    }, [
        limit,
        page,
        JSON.stringify(aggregations),
        dossierQuery,
        sort,
        searchParams,
        isInitialized,
    ])

    useEffect(() => {
        fetchSubscriptions()
    }, [dossiers])

    const handleEntriesChange = (event) => {
        setLimit(event.target.value)
        setPage(0)
    }

    const canBeArchived = () => {
        const dds = kedo.env().getCurrentEnvironmentDefDossiers()
        if (dds.length <= 0) {
            return false
        }

        return (
            dds.filter(
                (item) =>
                    item.id === props.defDossierId && item.archiveable === true
            ).length > 0
        )
    }

    const updateCheckedStatus = (event, dossier) => {
        const newSelected = selected.filter((checked) => checked !== dossier.id)

        if (event.target.checked === true) {
            newSelected.push(dossier.id)
        }

        setSelected(newSelected)
    }

    const clearSort = (e, listItem): void => {
        e.preventDefault()

        //Clear dossier column sorts.
        if (listItem.settings && listItem.settings.dossier_data) {
            const sortFields = sort.filter(
                (liItem) =>
                    liItem.item.setttings &&
                    liItem.item.settings.dossier_data !==
                        listItem.settings.dossier_data
            )
            setSort(sortFields)

            return
        }

        //Clear normal data fields.
        if (!listItem && !listItem.def_dossier_def_field) {
            return
        }

        const sortFields = sort.filter(
            (liItem) =>
                liItem.item.def_dossier_def_field.id !=
                listItem.def_dossier_def_field.id
        )
        setSort(sortFields)
    }

    const applySort = (e, listItem, listOrder): void => {
        e.preventDefault()

        if (
            listItem &&
            listItem.settings &&
            listItem.settings.dossier_data &&
            (listItem.settings.dossier_data === 'created_at' ||
                listItem.settings.dossier_data === 'modified_at')
        ) {
            const sortFields = sort.filter(
                (liItem) =>
                    !liItem.item ||
                    !liItem.item.settings ||
                    !liItem.item.settings.dossier_data ||
                    liItem.item.settings.dossier_data !==
                        listItem.settings.dossier_data
            )
            sortFields.push({ item: listItem, order: listOrder })
            setSort(sortFields)

            return
        }

        if (!listItem && !listItem.def_dossier_def_field) {
            return
        }

        const sortFields = sort.filter(
            (liItem) =>
                liItem.item.def_dossier_def_field.id !=
                listItem.def_dossier_def_field.id
        )
        sortFields.push({ item: listItem, order: listOrder })
        setSort(sortFields)
    }

    const onChangePage = (number) => {
        setPage(number)
    }

    const saveCurrentParams = (limit, number, defDossierId) => {
        const kedoUtils = kedo.utils()

        const pageItem = {
            pager: pager,
            limit: limit,
            current: number,
            defDossierId: props.defDossierId,
        }

        if (limit && limit.length > 0) pageItem.limit = limit
        if (number && number.length > 0) pageItem.current = number

        if (pageItem.limit || pageItem.current) {
            kedoUtils.createSavedLimit(pageItem)
        } else {
            kedoUtils.deleteSavedLimit(defDossierId)
        }
    }

    useEffect(() => {
        saveCurrentParams(limit, page, props.defDossierId)
    }, [onChangePage])

    const fetchSearchDisplayItems = async () => {
        if (loading) {
            return
        }

        const listResults = await entityService.getDisplayFields(
            props.defDossierId,
            { limit: 100, view: ['search', 'advanced-search'] }
        )

        setSearchItems(listResults.results)
        setLoading(false)
    }

    const isSelected = (dossier) => {
        return selected.find((selectedId) => selectedId === dossier.id)
    }

    const fetchSubscriptions = async () => {
        if (!dossiers || dossiers.length <= 0) {
            return
        }
        const response = await kedo
            .api()
            .post(kedo.api().getContentDossierEndpoint() + '/subscriptions', {
                ids: dossiers.map((item) => item.id),
            })
        setSubscriptions(response.data)
    }

    const getSearchFilter = () => {
        const filter = {
            defDossier: props.defDossierId,
            limit: limit,
            page: page,
            dossierQuery: null,
            sort: null,
            sortOrder: null,
            embedded: null,
            linkId: null,
            archived: null,
            dossierId: null,
            view: null,
        }

        if ((dossierQuery && dossierQuery.length > 0) || props.dossierQuery) {
            filter.dossierQuery = dossierQuery
                ? dossierQuery
                : props.dossierQuery
        }

        if (sort && sort.length > 0) {
            filter.sort = []
            filter.sortOrder = []
            sort.map((filterItem) => {
                filter.sort.push(
                    filterItem.item.def_dossier_def_field
                        ? filterItem.item.def_dossier_def_field.id
                        : filterItem.item.settings.dossier_data
                )
                filter.sortOrder.push(filterItem.order)
            })
        }

        if (props.embedded) {
            filter.embedded = props.embedded
            filter.linkId = props.linkId
        }

        if (searchParams && searchParams.length > 0) {
            searchParams.map((searchItem) => {
                if (
                    searchItem &&
                    searchItem.value &&
                    searchItem.value.custom === 'date'
                ) {
                    filter[searchItem.id + '_type'] = searchItem.value.type
                    if (searchItem.value.type === 'between') {
                        filter[searchItem.id + '_end'] = searchItem.value.date2
                    }
                    filter[searchItem.id] = searchItem.value.date1
                } else if (typeof searchItem.value === 'string') {
                    filter[searchItem.id] = searchItem.value
                } else if (
                    searchItem &&
                    searchItem.value &&
                    searchItem.value.custom === 'slider'
                ) {
                    filter[searchItem.id + '_min'] = searchItem.value.min
                    filter[searchItem.id + '_max'] = searchItem.value.max
                    filter[searchItem.id] = '1'
                } else if (searchItem.value instanceof Array) {
                    const values = []
                    searchItem.value.map((valItem) => values.push(valItem.id))
                    filter[searchItem.id] = values
                }
            })
        }

        return filter
    }

    const search = (values, dossierQuery) => {
        setSearchParams(values)
        setDossierQuery(dossierQuery)
        fetchDossierResults()
    }

    const renderSearchFilter = () => {
        if (
            searchItems.length <= 0 ||
            props.embedded ||
            props.initSearch === false
        ) {
            return null
        }
        const defDossier = kedo
            .env()
            .getCurrentEnvironmentDefDossiers()
            .find((item) => item.id === parseInt(props.defDossierId))

        return (
            <SearchDefDossier
                advancedSearch={advancedSearch}
                doSearch={doSearch}
                kedo={kedo}
                defDossierId={props.defDossierId}
                dossierQuery={dossierQuery}
                defDossier={defDossier}
                items={searchItems}
                showArchive={showArchived}
                resetSearch={() => setSearchParams([])}
                search={searchParams}
                location={'DefDossierIndex'}
            />
        )
    }

    useEffect(() => {
        setSort(
            DisplayItemHelper.mapSortSettings(
                props.ddiSort
                    ? props.ddiSort
                    : props.defDossier && props.defDossier.sort
                    ? props.defDossier.sort
                    : []
            )
        )
        setShowArchived(canBeArchived())

        const data = props.kedo.utils().getSavedSearch(props.defDossierId)

        if (data) {
            setSearchParams(data && data.search ? [...data.search] : null)
            setArchived(data && data.archived ? data.archived : null)
            setDossierQuery(
                props.dossierQuery
                    ? props.dossierQuery
                    : data && data.dossierQuery
                    ? data.dossierQuery
                    : null
            )
            setAdvancedSearch(
                data && data.advancedSearch ? data.advancedSearch : null
            )
        }

        const pageData = props.kedo.utils().getSavedLimit(props.defDossierId)

        if (pageData) {
            setPager(pageData?.pager ? pageData.pager : null)
        }
        loadSocketCallbacks()

        const fetchData = async () => {
            await fetchSearchDisplayItems()
            await fetchSubscriptions()
            await setIsInitialized(true)
            await fetchDossierResults()
        }
        fetchData()
    }, [])

    if (loading) {
        return (
            <div className={'container-fluid'}>
                <LoadingData />
            </div>
        )
    }
    if (error !== false) {
        return (
            <div className={'col-md-12'}>
                {expired ? <ExpiredModal kedo={kedo} /> : null}
                <Alert variant={'warning'}>
                    <FontAwesomeIcon icon={faExclamationCircle} />{' '}
                    {kedo.t('Something went wrong')}.
                </Alert>
            </div>
        )
    }

    const extraColumns = actionBtns.length > 0 ? 4 : 3

    return (
        <div>
            {props?.mode !== 'block' ? renderSearchFilter() : null}
            <Table size={'sm'} striped hover responsive>
                <ContentDossierIndexHeader
                    props={props}
                    loadingContent={loadingContent}
                    kedo={kedo}
                    sort={sort}
                    limit={limit}
                    handleEntriesChange={handleEntriesChange}
                    clearSort={clearSort}
                    applySort={applySort}
                    mode={props.mode}
                    pager={pager}
                    onDeleteSuccess={onDeleteSuccess}
                    subscriptions={subscriptions}
                    getSearchFilter={getSearchFilter}
                    dossiers={dossiers}
                    selected={selected}
                    setSelected={setSelected}
                    listItems={listItems}
                    actionBtns={actionBtns}
                    fetchDossierResults={fetchDossierResults}
                    defDossierId={props?.defDossierId}
                    showArchived={showArchived}
                />
                <ContentDossierIndexBody
                    kedo={kedo}
                    setSocketDossierIds={setSocketDossierIds}
                    contents={contents}
                    props={props}
                    fetchDossierResults={fetchDossierResults}
                    mode={props?.mode}
                    setInlineEdit={setInlineEdit}
                    loadingContent={loadingContent}
                    subscriptions={subscriptions}
                    extraColumns={extraColumns}
                    dossiers={dossiers}
                    listItems={listItems}
                    actionBtns={actionBtns}
                    socketDossierIds={socketDossierIds}
                    onSelect={(event, dossier) =>
                        updateCheckedStatus(event, dossier)
                    }
                    isSelected={isSelected}
                    showEmail={props?.showEmail}
                />
                <ContentDossierIndexFooter
                    resultAggregations={resultAggregations}
                    loadingContent={loadingContent}
                    listItems={listItems}
                    kedo={kedo}
                    dossiers={dossiers}
                    extraColumns={extraColumns}
                    aggregations={aggregations}
                    setAggregations={setAggregations}
                    onChangePage={onChangePage}
                    pager={pager}
                />
            </Table>
            {inlineEdit ? (
                <DossierModalEditButton
                    onDeleteSuccess={() => handleDossierModal(true, false)}
                    showSaveClose={true}
                    onSuccess={(close) => {
                        handleDossierModal(true, close)
                    }}
                    onClose={() => handleDossierModal(false, true)}
                    embedded={props.embedded}
                    edit={true}
                    dossierId={inlineEdit}
                    kedo={kedo}
                />
            ) : null}
        </div>
    )
}

export default React.forwardRef(ContentDossierIndex)
